import { isIE } from "react-device-detect"

export const CheckBrowserIsIE = () => {
  if (isIE) {
    alert(
      "AVERTISSEMENT : Internet Explorer n'est pas supporté par ce site et sera mis hors service en 2022. Pour une navigation améliorée, nous vous invitons à passer sur les navigateurs EDGE, CHROME ou FIREFOX. Merci de votre compréhension. Les Territoires Numériques BFC."
    )
  }
}
